import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/pro-regular-svg-icons";

import "./Banner.scss";

interface IProps {
    description: React.ReactNode;
}

const WarningBanner = (props: IProps) => {
    return (
        <div className="userful-warning-banner-wrapper">
            <div className="userful-warning-banner-icon-wrapper">
                <FontAwesomeIcon icon={faWarning} />
            </div>
            <div className="userful-warning-banner-text-wrapper">
                <p>{props.description}</p>
            </div>
        </div>
    );
};

export default WarningBanner;
